"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeMsg = exports.MsgDecoder = void 0;
var _messageModel = require("./messageModel");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MAX_MESSAGE_CHARACTERS = 4096;
var MsgDecoder = exports.MsgDecoder = /*#__PURE__*/_createClass(function MsgDecoder() {
  var _this = this;
  _classCallCheck(this, MsgDecoder);
  _defineProperty(this, "receiveMessagesCache", []);
  _defineProperty(this, "decodeMsg", function (msg) {
    _this.receiveMessagesCache.push(msg);
    if (msg.last) {
      var completeMessage = _this.receiveMessagesCache.reduce(function (acc, item) {
        acc = acc + item.payload;
        return acc;
      }, "");
      _this.receiveMessagesCache.length = 0;
      return new _messageModel.Message(new _messageModel.MessageDefinition(msg.msgCategory, msg.msgType), completeMessage);
    } else {
      return undefined;
    }
  });
});
var encodeMsg = exports.encodeMsg = function encodeMsg(msgDef, data) {
  var payload = "";
  if (data) {
    if (_typeof(data) === "object") {
      payload = JSON.stringify(data);
    } else if (typeof data === "string") {
      payload = "\"".concat(data, "\"");
    } else {
      payload = "" + data;
    }
  }
  console.debug("Sending msg: " + payload);
  if (payload.length <= MAX_MESSAGE_CHARACTERS) {
    return [new _messageModel.Message(msgDef, payload)];
  }
  var msgs = [];
  var remaining = payload.length;
  var position = 0;
  while (remaining > 0) {
    var increment = Math.min(MAX_MESSAGE_CHARACTERS, remaining);
    remaining -= increment;
    var last = remaining === 0;
    var segment = payload.substring(position, position + increment);
    position += increment;
    msgs.push(new _messageModel.Message(msgDef, segment, last));
  }
  return msgs;
};